function defaultState() {
  return {
    showingEventDialog: false,
    eventId: null
  }
}

const state = defaultState();

const getters = {};

const mutations = {
  setShowingEventDialog(state, value) {
    state.showingEventDialog = value;
  },
  setEventId(state, value) {
    state.eventId = value;
  },
  _reset(state) {
    const initialState = defaultState();
    for (const key in state) {
      if (state.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  }
};

const actions = {
  showEventDialog({commit}, payload) {
    commit('setEventId', payload);
    commit('setShowingEventDialog', true)
  },
  hideEventDialog({commit}) {
    commit('setEventId', null);
    commit('setShowingEventDialog', false)
  },
  signOutReset({commit}) {
    commit('_reset');
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
